<template>
  <div>
    <el-dialog :title="$t('message.normalWarehouse')" :close-on-click-modal="false" :visible.sync="show" width="1800px">
      <div class="search">
        <el-input v-model="orderSnKeyword" placeholder="订单号" clearable @keyup.enter.native="searchLocalData"></el-input>
        <el-input v-model="forSnKeyword" placeholder="管理番号" clearable @keyup.enter.native="searchLocalData"></el-input>
        <el-button type="primary" @click="searchLocalData">搜索</el-button>
        <el-button @click="resetLocalSearch">重置</el-button>
      </div>
      <div class="table" v-infinite-scroll="lazyLoading" infinite-scroll-distance="300">
        <ol>
          <li class="flex05">NO</li>
          <!-- 选择 -->
          <li class="choose flex05">
            {{ $t("message.choose") }}
          </li>
          <!-- 照片 -->
          <li class="photo">{{ $t("message.photo") }}</li>
          <!-- 商品名称 -->
          <li class="productName flex15">{{ $t("message.productName") }}</li>
          <!-- 商品规格 -->
          <li class="productSpecifications">
            {{ $t("message.productSpecifications") }}
          </li>
          <!-- 购入数据 -->
          <li class="purchaseData">{{ $t("message.purchaseData") }}</li>
          <!-- 备注栏 -->
          <li class="remarksField flex15">
            {{ $t("message.remarksField") }}
          </li>
          <!-- 附加服务 -->
          <li class="additionalServices">
            {{ $t("message.additionalServices") }}
          </li>
          <!-- 标签编号 -->
          <li class="additionalServices">
            {{ $t("message.tagNumber") }}
          </li>
          <!-- 在rakumart仓库数量 -->
          <li class="numberOfWarehousesInRakumart">
            {{ $t("message.numberOfWarehousesInRakumart") }}
          </li>
          <!-- 已提出数 -->
          <li class="numberProposed">
            {{ $t("message.numberProposed") }}
          </li>
          <!-- 可提出数 -->
          <li class="numbersCanBeProposed">
            {{ $t("message.numbersCanBeProposed") }}
          </li>
          <!-- 装箱数量 -->
          <li class="loadingTheNumberOfBoxes">
            {{ $t("message.loadingTheNumberOfBoxes") }}
          </li>
          <!-- 追加数量 -->
          <li class="loadingTheNumberOfBoxes" v-if="routeName == 'porderDetail'">
            {{ $t("message.additionalQuantity") }}
          </li>
        </ol>
        <div v-for="(tableItem, tableIndex) in tableData" :key="tableIndex">
          <div class="c" v-for="(orderitem, orderindex) in tableItem.order" :key="orderindex">
            <div class="boxTitle">
              <el-checkbox v-model="orderitem.checked" @change="orderCheck(orderitem)" />
              <router-link class="link" :to="'/orderDetail?order_sn=' + orderitem.order_sn" target="_blank">
                <!-- 订单号 -->
                {{ $t("message.orderNumber") }}:{{
                  orderitem.order_sn
                }}</router-link>
            </div>
            <ul v-for="(goodsItem, goodsIndex) in orderitem.order_detail" :key="goodsIndex">
              <li class="flex05">{{ goodsItem.sorting }}</li>
              <!-- 选择 -->
              <li class="chiose flex05">
                <el-checkbox v-model="goodsItem.checked" @change="goodsCheck(orderitem, goodsItem)" />
              </li>
              <!-- 照片 -->
              <li class="photo">
                <div>
                  <el-popover placement="right" trigger="hover">
                    <img :src="goodsItem.pic" alt="" style="width: 300px; height: 300px" />
                    <el-image :src="goodsItem.pic" slot="reference" class="gooodsImg">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                      <div slot="placeholder">
                        <i class="el-icon-loading"></i>
                      </div>
                    </el-image>
                  </el-popover>
                  <p>{{ goodsItem.for_sn }}</p>
                </div>

              </li>
              <!-- 商品名称 -->
              <li class="productName flex15">
                <el-popover placement="bottom" width="400" trigger="hover">
                  <p>{{ goodsItem.goods_title }}</p>
                  <span slot="reference">
                    {{ goodsItem.goods_title }}
                  </span>
                </el-popover>
              </li>
              <!-- 商品规格 -->
              <li class="productSpecifications">
                <el-popover placement="bottom" trigger="hover">
                  <div class="orderDetailAll">
                    <div class="detailAllCon">
                      <p v-for="(detailItem, detailIndex) in goodsItem.detail" :key="detailIndex">
                        <span> {{ detailItem.key }}: </span>
                        <span>{{ detailItem.value }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="goodsDetail" slot="reference">
                    <p v-for="(detailItem, detailIndex) in goodsItem.detail" :key="detailIndex">
                      <span> {{ detailItem.key }}: </span>
                      <span>{{ detailItem.value }}</span>
                    </p>
                  </div>
                </el-popover>
              </li>
              <!-- 购入数据 -->
              <li class="purchaseData">
                <div>
                  <p>
                    <!-- 数量 -->
                    <span>{{ $t("message.quantity") }}:</span>
                    <span class="blurFont">
                      {{ goodsItem.confirm_num }}
                    </span>
                  </p>
                  <p>
                    <!-- 单价 -->
                    <span>{{ $t("message.unitPrice") }}:</span>
                    <span class="redFont">
                      {{ goodsItem.confirm_price }}
                    </span>
                  </p>
                  <p>
                    <!-- 国内运费 -->
                    <span>{{ $t("message.domesticFreight") }}:</span>
                    <span class="redFont">
                      {{ goodsItem.confirm_freight }}
                    </span>
                  </p>
                  <p>
                    <!-- 小计 -->
                    <span>{{ $t("message.subtotal") }}:</span>
                    <span class="blurFont">
                      {{
                        (
                          goodsItem.confirm_num *
                          goodsItem.confirm_price *
                          goodsItem.confirm_freight
                        ).toFixed(2)
                      }}
                    </span>
                  </p>
                </div>
              </li>
              <!-- 备注栏 -->
              <li class="remarksField flex15">
                <textarea disabled v-model="goodsItem.client_remark"> </textarea>
              </li>
              <!-- 附加服务 -->
              <li class="additionalServices">
                <el-popover min-width="400" placement="bottom" trigger="hover">
                  <div class="optionListBig table">
                    <el-table v-if="goodsItem.option" :data="goodsItem.option" border size="mini" show-summary>
                      <!-- 类型 -->
                      <el-table-column property="name" :label="$t('message.type')" align="center">
                        <template slot-scope="scope">
                          <div>
                            <span>{{ scope.$index + 1 }}) </span>
                            <span>&{{ scope.row.name }}</span>
                          </div>
                        </template>
                      </el-table-column>
                      <!-- 数量 -->
                      <el-table-column property="num" :label="$t('message.quantity')" align="center"></el-table-column>
                      <!-- 单价 -->
                      <el-table-column :label="$t('message.unitPrice')" align="center">
                        <template slot-scope="scope">
                          {{ scope.row.price }} {{ scope.row.unit }}
                        </template>
                      </el-table-column>
                      <!-- 小计 -->
                      <el-table-column :label="$t('message.subtotal')" align="center" property="total">
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="optionList" slot="reference">
                    <p v-for="(optionItem, optionIndex) in goodsItem.option" :key="optionIndex">
                      <span>{{ optionIndex + 1 }}) </span>
                      <span>{{ optionItem.name }}</span>
                    </p>
                  </div>
                </el-popover>
              </li>
              <!-- 标签编号 -->
              <li class="additionalServices">
                <div class="tabInfomation">
                  <div class="item" v-for="(tag, tagIndex) in goodsItem.order_detail_tag" :key="tagIndex">
                    <p>类别:{{ tag.type }}</p>
                    <p>标签号:{{ tag.no }}</p>
                    <p>商品码:{{ tag.goods_no }}</p>
                  </div>
                </div>
              </li>
              <!-- 在rakumart仓库数量 -->
              <li class="numberOfWarehousesInRakumart">
                {{ goodsItem.is_rakumart_stcok_num }}
              </li>
              <!-- 已提出数 -->
              <li class="numberProposed">
                {{ goodsItem.send_success_num }}
              </li>
              <!-- 可提出数 -->
              <li class="numbersCanBeProposed">
                {{ goodsItem.send_await_num }}
              </li>
              <!-- 装箱数量 -->
              <li class="loadingTheNumberOfBoxes">
                {{ goodsItem.is_box_num }}
              </li>
              <!-- 追加数量 -->
              <li class="loadingTheNumberOfBoxes" v-if="routeName == 'porderDetail'">
                <el-input v-model="goodsItem.num" style="margin: 0 20px;"
                  @input="handleInputPrice(goodsItem)"></el-input>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="order == false || tableData == false || (tableData[0] && tableData[0].order == false)"
          class="No_data">
          暂无数据
        </div>
      </div>
      <!-- 操作栏 -->
      <div class="operate">
        <!-- 全选 -->
        <el-checkbox v-model="checked" @change="checkAll()">{{
          $t("message.allChecked")
        }}</el-checkbox>
        <!-- 提出配送单 -->
        <div class="rightBox">
          <div class="numberOfProducts">
            <span>已选:</span>
            <span class="redFont"> {{ checkNum }} 件</span>
          </div>
          <!-- 追加到配送单 -->
          <el-button size="mini" type="primary" class="fr" @click="appendDeliverylist">
            {{ $t("message.appendDeliverylist") }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user_id: this.$route.query.userID ? this.$route.query.userID : this.$route.query.porder_sn.split('-')[1],
      tableData: [],
      order: [],//这里复制的仓库的格式,否则要重新写单选多选等方法
      show: false,
      checked: false,
      checkNum: 0, // 已选商品番数
      chioseIdArr: [],//已选中的id
      chioseGoodsArr: [],// 已选中的商品所有数据
      sourceOrder: [],//当前请求返回的原始订单数据
      orderSnKeyword: '',//订单号筛选关键字
      forSnKeyword: '',//管理番号筛选关键字
      routeName: this.$route.name //哪个页面打开
    };
  },
  components: {
  },
  computed: {
  },
  created() {
  },
  methods: {
    // 追加到配送单
    appendDeliverylist() {
      if (this.routeName == 'deliveryPreview') {  //
        for (let i in this.chioseGoodsArr) {
          this.chioseGoodsArr[i].checked = false
          if (this.chioseGoodsArr[i].porder_detail != null) {
            this.chioseGoodsArr[i].porder_detail[0].text_line_four = ''
            this.chioseGoodsArr[i].porder_detail[0].text_line_one = ''
            this.chioseGoodsArr[i].porder_detail[0].text_line_three = ''
            this.chioseGoodsArr[i].porder_detail[0].text_line_two = ''
          }
          this.$parent.tableData.push(this.chioseGoodsArr[i])
          console.log(this.chioseGoodsArr[i]);
        }
        this.show = false
        this.$parent.checked = false//把页面操作栏上的全选设为false
      } else if (this.routeName == 'porderDetail') {
        let porder_sn = this.$route.query.porder_sn
        let datas = {
          porder_sn,
          order_detail: []
        }
        this.chioseGoodsArr.forEach(item => {
          datas.order_detail.push({
            id: item.id,
            order_sn: item.order_sn,
            send_await_num: item.num,
            order_detail_tag: item.order_detail_tag,
            y_remark: item.client_remark,
            client_remark:item.client_remark
          })
        })
        if (datas.order_detail == false) return this.$message.error('未选择商品')
        this.$api.porderApi.appendPorderDetail(datas).then(res => {
          this.$message.success(res.msg)
          this.show = false
          this.$store.dispatch("porderDetail", { porder_sn })
        })
      }
    },
    // 全选
    checkAll() {
      this.order.forEach((item) => {
        item.checked = this.checked;
        item.order_detail.forEach((item2) => {
          item2.checked = this.checked;
        });
      });
      this.getcheckNum();
    },
    // 检查是否全部选上了
    ischeck() {
      var flag = this.order.every((item, index) => item.checked == true);
      if (flag == true) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    // 订单单选
    orderCheck(orderItem) {
      orderItem.order_detail.forEach((item) => {
        item.checked = orderItem.checked;
      });
      this.ischeck();
      this.getcheckNum();
    },
    // 商品单选
    goodsCheck(orderItem, goodsItem) {
      orderItem.checked = orderItem.order_detail.every(
        (item, index) => item.checked == true
      );
      this.ischeck();
      this.getcheckNum();
    },
    // 统计已选数据
    getcheckNum() {
      // 商品番数
      this.checkNum = 0;
      // 选中商品id
      this.chioseIdArr = [];
      this.chioseGoodsArr = []
      this.order.forEach((item) => {
        item.order_detail.forEach((item2) => {
          if (item2.checked) {
            this.checkNum++;
            this.chioseIdArr.push(item2.id);
            item2.order_detail_id = item2.id
            this.chioseGoodsArr.push(item2)
          }
        });
      });

    },
    /**
     * 重置追加商品弹框状态，避免重新打开时懒加载复用上一次的勾选数据。
     */
    resetDialogState() {
      this.checked = false
      this.checkNum = 0
      this.chioseIdArr = []
      this.chioseGoodsArr = []
      this.order = []
      this.sourceOrder = []
      this.tableData = [{ order: [] }]
    },
    // 打开弹窗时先清理旧数据，再重新请求当前可追加商品。
    open() {
      this.orderSnKeyword = ''
      this.forSnKeyword = ''
      this.resetDialogState()
      this.porderPreviewAddBeStockAuto()
      this.show = true
    },
    // 重置当前展示列表并继续沿用懒加载填充
    resetLazyList() {
      this.tableData = [
        {
          order: [],
        },
      ];
      this.checked = false
      this.getcheckNum()
      this.lazyLoading()
    },
    // 在当前接口返回的数据上按订单号和管理番号筛选
    filterSourceOrder() {
      const orderSnKeyword = (this.orderSnKeyword || '').trim()
      const forSnKeyword = (this.forSnKeyword || '').trim()
      return this.sourceOrder.reduce((list, item) => {
        if (orderSnKeyword && String(item.order_sn || '').indexOf(orderSnKeyword) == -1) {
          return list
        }
        const orderItem = JSON.parse(JSON.stringify(item))
        if (forSnKeyword) {
          orderItem.order_detail = orderItem.order_detail.filter(goods => {
            return String(goods.for_sn || '').indexOf(forSnKeyword) != -1
          })
        }
        if (orderItem.order_detail.length) {
          list.push(orderItem)
        }
        return list
      }, [])
    },
    // 搜索当前已请求回来的订单数据
    searchLocalData() {
      this.order = this.filterSourceOrder()
      this.resetLazyList()
    },
    // 清空筛选项并恢复当前请求返回的数据
    resetLocalSearch() {
      this.orderSnKeyword = ''
      this.forSnKeyword = ''
      this.searchLocalData()
    },
    porderPreviewAddBeStockAuto() {
      let haveGoods = []//已在配送单中的商品id
      this.tableData = [
        {
          order: [],
        },
      ];
      if (this.routeName == 'deliveryPreview') {
        this.$parent.tableData.forEach((item) => {
          haveGoods.push(item.id)
        })
      } else if (this.routeName == 'porderDetail') {
        this.$parent.list.forEach((item) => {
          haveGoods.push(item.order_detail_id)
        })
      }
      this.$api.clienteleApi
        .porderPreviewAddBeStockAuto({
          user_id: this.user_id,
          overlook_order_detail_id: haveGoods.join(',')
        }).then(res => {
          if (res.code != 0) return
          res.data.forEach(item => {
            item.order_detail.forEach(items => {
              items.num = items.send_await_num
            })
          })
          this.sourceOrder = JSON.parse(JSON.stringify(res.data));
          this.order = this.filterSourceOrder()

          // 懒加载
          this.lazyLoading()
        })
    },
    // 懒加载
    lazyLoading() {
      if (this.tableData[0].order.length >= this.order.length) return
      this.tableData[0].order = [...this.tableData[0].order, ... this.order.slice(this.tableData[0].order.length, this.tableData[0].order.length + 10)]
    },
    // 不能输入负数
    handleInputPrice(item) {
      item.num = ("" + item.num) // 第一步：转成字符串
        .replace(/[^0-9]/g, '') // 第二步：把不是数字
      if (item.num > item.send_await_num) {
        item.num = item.send_await_num
      }
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import '@/css/mixin.scss';

.search {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  .el-input {
    width: 220px;
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 12px;
  max-height: 1000px;
  overflow-y: auto;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }

    .tabInfomation {
      width: 100%;
      text-align: left;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    min-height: 100px;

    &:hover {
      background-color: #fff;
    }

    .template {
      text-align: center;

      p {
        margin-bottom: 5px;
      }
    }

    .attribute {
      text-align: left;
      width: 100%;

      .row {
        width: 100%;
        margin-bottom: 5px;
      }
    }

    .services {
      text-align: left;
    }

    .text {
      padding: 5px;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }

    .pic {
      position: relative;
    }

    .edit {
      width: 20px;
      height: 20px;
      margin-left: 5px;

      i {
        font-size: 20px;
        color: #2c96e7;
        cursor: pointer;
      }
    }
  }
}

.boxInfo {
  padding-left: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #d2d2d2;

  >* {
    margin-right: 20px;
  }
}

.boxTitle {
  padding-left: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #d2d2d2;

  >* {
    margin-right: 20px;
  }

  .link {
    color: red;
    text-decoration: underline;
    cursor: pointer;
  }
}

.orderBox {


  .gooodsImg {
    width: 80px;
    height: 80px;
  }

  .productName {
    span {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }

  .productSpecifications {
    .goodsDetail {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}

.remarksField {
  textarea {
    width: 100%;
    height: 80px;
    padding: 5px;
    box-sizing: border-box;
  }
}



.optionList {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.operate {
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 9;
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  label {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      margin-left: 20px;
    }
  }

  .rightBox {
    display: flex;
    align-items: center;

    .numberOfProducts {
      margin-right: 20px;
    }
  }
}
</style>
